import React, { useEffect, useRef, useState } from "react";
import { classes } from "../../../core/data/json/classes";
import NewDatatable from "../../../core/common/dataTable/NewDatatable";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { acadamicTerms, activeList } from "../../../core/common/selectoption/selectoption";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { Link, useNavigate } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import { _get, _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import { DatePicker, Input, TimePicker } from "antd";
import moment from "moment";
const SchoolTermSetup = () => {
    const _form = {
        query_type: "create",
        school_id: "",
        section_id: "",
        section_name: "",
        address: "",
        school_name: "",
        year: "",
        begin_date: "",
        end_date: "",
        term: "",
        status: "Active"
    };

    const [form, setForm] = useState(_form);
    const [loading, setLoading] = useState(false);
    const handleChange = (e: any) => {
        setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
    };
    const navigate = useNavigate();
    const [new_data, setNewData] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [sections, setSections] = useState([]);
    const classSection = sections?.map((section: any) => ({
        value: section.section_id,
        label: section.section_name,
    }));
    const terms = [
        { value: "", label: "Select" },
        { value: "FIRST TERM", label: "FIRST TERM" },
        { value: "SECOND TERM", label: "SECOND TERM" },
        { value: "THIRD TERM", label: "THIRD TERM" },
    ];
    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    }

    const getAcademicYears = () => {
        _get(
            "get-academic-years",
            (res) => {
                console.log(res);
                setAcademicYears(res.results);
            },
            (err) => {
                // setLoading(false)
                console.log(err);
            }
        );
    };

    const [selectedTerm, setSelectedTerm] = useState<any>(null);

    useEffect(() => {
        getAcademicYears();
    }, []);

    const handleSubmit = () => {
        // e.preventDefault();

        _post(
            "create-academic-years",
            { ...form, begin_date: moment(form.begin_date).format("YYYY-MM-DD"), end_date: moment(form.end_date).format("YYYY-MM-DD") },
            (res) => {
                if (res.success) {
                    toast.success("Submitted successfully");
                    //    getExamSchedules();
                }
            },
            (err) => {
                // Handle error
                toast.error(err);
                console.error("Submission failed:", err);
            }
        );

        // Reset the form after submission
        setForm(_form);
    };

    const routes = all_routes;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };
    const route = all_routes;
    const columns = [
        {
            title: "#",
            dataIndex: "id",
            render: (text: string, record: any, index: number) => (
                <>
                    {/* <Link to="#" className="link-primary"> */}
                    {index + 1}
                    {/* </Link> */}
                </>
            ),
        },
        {
            title: "Term Setup",
            dataIndex: "academic_year",
        },
        {
            title: "Term",
            dataIndex: "term",
        },
        {
            title: "Start Date",
            dataIndex: "begin_date",
        },
        {
            title: "End Date",
            dataIndex: "end_date",
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string) => (
                <>
                    {text === "active" ? (
                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                            <i className="ti ti-circle-filled fs-5 me-1"></i>
                            {text}
                        </span>
                    ) : (
                        <span className="badge badge-soft-danger d-inline-flex align-items-center">
                            <i className="ti ti-circle-filled fs-5 me-1"></i>
                            {text}
                        </span>
                    )}
                </>
            ),
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text: string, record: any) => (
                <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => {
                        setForm((p) => ({ ...p, term: record.term }));
                        setSelectedTerm(record);
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#add_year"
                >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                </Link>
            ),
        },
    ];
    return (
        <div>
            {/* Page Wrapper */}
            {JSON.stringify(sections)}
            <div className="page-wrapper">
                <div className="content">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Term Setup</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={route.adminDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="#">School Setup</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Term Setup
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {/* <TooltipOption /> */}
                            {/* <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_year"
                  className="btn btn-primary"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Term Setup
                </Link>
              </div> */}
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Manage Terms</h4>
                            <div className="d-flex align-items-center flex-wrap">
                                {/* <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">School Name</label>
                              <input
                                className="form-control"
                                name={"school_name"}
                                defaultValue={form.school_name}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={activeList}
                                defaultValue={activeList[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div> */}
                            </div>
                        </div>
                        {/* {JSON.stringify(terms)} */}
                        <div className="card-body p-0 py-3">
                            <NewDatatable
                                columns={columns}
                                dataSource={academicYears}
                                Selection={false}
                                pageSize={10}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <>
                {/* add section modal */}
                <div className="modal fade" id="add_year">
                    <div className="modal-dialog modal-dialog-centered  modal-sm">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Term</h4>
                                <button
                                    type="button"
                                    className="btn-close custom-btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="ti ti-x" />
                                </button>
                            </div>

                            <form>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Term</label>
                                                        <Input
                                                            disabled={true}
                                                            value={selectedTerm?.term}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Status</label>
                                                        <CommonSelect
                                                        options={['Active','Inactive'].map((status:string)=>({
                                                            label:status,
                                                            value:status,
                                                        }))}
                                                            defaultValue={{
                                                                label:selectedTerm?.term,
                                                                value:selectedTerm?.term,
                                                            }}
                                                        />
                                                        <Input
                                                            disabled={true}
                                                            value={selectedTerm?.status}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Opening Date</label>
                                                        <div className="date-pic">
                                                            <DatePicker
                                                                getPopupContainer={getModalContainer}
                                                                // use12Hours
                                                                placeholder="Choose Opening Date"
                                                                format="YYYY-MM-DD"
                                                                className="form-control timepicker"
                                                                name="begin_date"
                                                                value={moment(selectedTerm?.begin_date)}
                                                                onChange={(date) => {
                                                                    // Check if a valid time is selected
                                                                    if (date) {
                                                                        setForm((prev: any) => ({
                                                                            ...prev,
                                                                            begin_date: date.toDate(), // Store as Date object
                                                                        }));
                                                                    } else {
                                                                        setForm((prev: any) => ({
                                                                            ...prev,
                                                                            begin_date: null, // Reset if no valid time is selected
                                                                        }));
                                                                    }
                                                                }}
                                                            />

                                                            <span className="cal-icon">
                                                                <i className="ti ti-clock" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Closing Date</label>
                                                        <div className="date-pic">
                                                            <DatePicker
                                                                getPopupContainer={getModalContainer}
                                                                // use12Hours
                                                                placeholder="Choose Closing Date"
                                                                format="YYYY-MM-DD"
                                                                className="form-control timepicker"
                                                                value={moment(selectedTerm?.end_date)}
                                                                name="end_date"
                                                                onChange={(date) => {
                                                                    // Check if a valid time is selected
                                                                    if (date) {
                                                                        setForm((prev: any) => ({
                                                                            ...prev,
                                                                            end_date: date.toDate(), // Store as Date object
                                                                        }));
                                                                    } else {
                                                                        setForm((prev: any) => ({
                                                                            ...prev,
                                                                            end_date: null, // Reset if no valid time is selected
                                                                        }));
                                                                    }
                                                                }}
                                                            />

                                                            <span className="cal-icon">
                                                                <i className="ti ti-clock" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <Link
                                        to="#"
                                        className="btn btn-warning me-2"
                                        data-bs-dismiss="modal"
                                    >
                                        Cancel
                                    </Link>
                                    <Link
                                        to="#"
                                        className="btn btn-primary"
                                        data-bs-dismiss="modal"
                                        onClick={() => handleSubmit()}
                                    >
                                        Submit
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
};

export default SchoolTermSetup;
